// Imports ------------------------------------------------------------------->

import { Component } from '../Component'
import { element } from '../CustomElement'

import { inject } from '../../services/di'
import { AuthenticationService } from '../../services/AuthenticationService'
import { ConfigService } from '../../services/ConfigService'
import { icons } from '../../icons/Icons'
import { i18n } from '../../i18n/I18n'
import { Link } from '../flipp-link/Link'
import { LinkService } from '../../services/LinkService'
import { EventService } from '../../services/EventService'
import { AnalyticsService } from '../../services/AnalyticsService'
import { FormInput } from '../flipp-form-input/FormInput'
import {
    handleFormInputsChange,
    handleSubmitRequest,
    hasEmptyFields,
    setDocumentTitle,
} from './Login.helper'

@element('flipp-change-password-page')
export class ChangePasswordPage extends Component<any, void> {
    @inject config: ConfigService
    @inject auth: AuthenticationService
    @inject eventService: EventService
    @inject analytics: AnalyticsService

    refs: {
        submitForm: HTMLFormElement
        submitBtn: HTMLElement
        spinner: HTMLElement
        previousPasswordInput: FormInput
        passwordInput: FormInput
        confirmPasswordInput: FormInput
        submitBtnText: HTMLElement
        responseErrorMsg: HTMLElement
        passwordPolicy: HTMLElement
    }

    state = {
        previous_password: '',
        password: '',
        confirm_password: '',
    }

    onCreate() {
        setDocumentTitle(i18n('change_password_header'))
    }

    async onAttach() {
        document.title = `${i18n('change_password_header')} | Flipp`
        this.state.previous_password = ''
        this.state.password = ''
        this.state.confirm_password = ''
        const res = await this.auth.getPasswordRequirements()
        this.refs.passwordPolicy.textContent = res.password_requirements
    }

    render() {
        return (
            <main>
                <div class="top-bar">
                    <Link to="listing" class="flipp-logo" title="Flipp">
                        {icons.flippLogoWhite}
                    </Link>
                </div>
                <div class="one-column-content">
                    <div class="one-column-picture">
                        <img
                            src={`https://f.wishabi.net/creative/Distribution/images/reset-password.svg`}
                            alt=""
                        />
                    </div>
                    <div class="header">{i18n('change_password_header')}</div>
                    <div class="one-column-text">
                        {i18n('change_password_text')}
                    </div>
                    <div class="one-column-form">
                        <form name="submitForm" ref="submitForm">
                            <FormInput
                                ref="previousPasswordInput"
                                name={'previous_password'}
                                handleChange={this.handleChange}
                                type={'password'}
                                placeholder={i18n('previous_password')}
                            />
                            <FormInput
                                ref="passwordInput"
                                name={'password'}
                                handleChange={this.handleChange}
                                type={'password'}
                                placeholder={i18n('new_password')}
                            />
                            <FormInput
                                ref="confirmPasswordInput"
                                name={'confirm_password'}
                                handleChange={this.handleChange}
                                type={'password'}
                                placeholder={i18n('confirm_password')}
                            />
                            <div ref="passwordPolicy" class="password-policy">
                                {i18n('password_policy')}
                            </div>
                            <div class="button-container">
                                <button
                                    ref="submitBtn"
                                    class="flipp-button"
                                    onClick={this.handleSubmit}
                                >
                                    <div
                                        ref="spinner"
                                        class="spinner hide"
                                    ></div>
                                    <div
                                        ref="submitBtnText"
                                        class="submit-button-text"
                                    >
                                        {i18n('signin')}
                                    </div>
                                </button>
                                <p ref="responseErrorMsg" class="error-msg"></p>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        )
    }

    private changePassword = async () => {
        await this.auth.changePassword({
            previous_password: this.state.previous_password,
            new_password: this.state.password,
        })
        const linkService = LinkService.getInstance()
        linkService.execute('weekly_ads', this)
    }

    private handleChange = (e: any) => {
        this.state = handleFormInputsChange(this.state, this.refs, e)
    }

    private handleSubmit = async (e: any) => {
        e.preventDefault()
        this.refs.responseErrorMsg.textContent = ''
        if (hasEmptyFields(this.state)) {
            if (this.state.previous_password.length === 0) {
                this.refs.previousPasswordInput.errorMessage = i18n(
                    'enter_previous_password_error'
                )
            }
            if (this.state.password.length === 0) {
                this.refs.passwordInput.errorMessage = i18n(
                    'enter_password_error'
                )
            }
            if (this.state.confirm_password.length === 0) {
                this.refs.confirmPasswordInput.errorMessage = i18n(
                    'confirm_password_error'
                )
            }
        }
        if (
            this.state.password &&
            this.state.confirm_password &&
            this.state.password !== this.state.confirm_password
        ) {
            this.refs.confirmPasswordInput.errorMessage = i18n(
                'passwords_mismatch_error'
            )
        } else if (!hasEmptyFields(this.state)) {
            await handleSubmitRequest(
                this.refs,
                this.changePassword,
                (body) => {
                    if (body.code === 'USER_NOT_CONFIRMED') {
                        this.refs.responseErrorMsg.textContent =
                            i18n('USER_NOT_CONFIRMED')
                    }
                }
            )
        }
    }
}
